var NodeType = /* @__PURE__ */ ((NodeType2) => {
  NodeType2["Translation"] = "translation";
  NodeType2["Enumeration"] = "enumeration";
  NodeType2["Condition"] = "condition";
  NodeType2["Insertion"] = "insertion";
  NodeType2["File"] = "file";
  NodeType2["Object"] = "object";
  NodeType2["Array"] = "array";
  NodeType2["Nested"] = "nested";
  NodeType2["ReactNode"] = "reactNode";
  NodeType2["Markdown"] = "markdown";
  NodeType2["Text"] = "text";
  NodeType2["Number"] = "number";
  NodeType2["Boolean"] = "boolean";
  NodeType2["Gender"] = "gender";
  NodeType2["Unknown"] = "unknown";
  return NodeType2;
})(NodeType || {});
const formatNodeType = (nodeType, content, additionalAttributes) => ({
  ...additionalAttributes,
  nodeType,
  [nodeType]: content
});
export {
  NodeType,
  formatNodeType
};
//# sourceMappingURL=nodeType.mjs.map